// Gaya tooltip Recharts bersama utk SEMUA grafik (Dashboard, Orientasi RS, Rotasi
// Klinik per Instalasi). Memakai token tema (--popover, --popover-foreground,
// --border di index.css) lewat CSS var, jadi otomatis benar di mode terang & gelap
// tanpa cabang isDark. itemStyle WAJIB diisi: tooltip bawaan Recharts mewarnai teks
// tiap baris dgn warna seri, dan jatuh ke hitam (#000) bila seri tidak punya warna
// sendiri (mis. Pie/Bar yg warnanya di <Cell>) -> tidak terbaca di mode gelap.
const TEKS = "hsl(var(--popover-foreground))";

export const chartTooltipProps = {
    contentStyle: {
        background: "hsl(var(--popover))",
        border: "1px solid hsl(var(--border))",
        borderRadius: 8,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.18)",
        color: TEKS,
        fontSize: 12,
    },
    labelStyle: { color: TEKS, fontWeight: 700 },
    itemStyle: { color: TEKS },
};

// Angka tooltip berpemisah ribuan Indonesia (2.407), sama dgn daftar/label grafik.
export const formatAngkaTooltip = (v) => (typeof v === "number" ? v.toLocaleString("id-ID") : v);
